import {Base64} from 'js-base64'

export default class ModifyPhoneParam {
  constructor({ identity, appCode, appServiceCode, verifyCode }, phone) {
    this.loginName = phone
    this.phone = identity
    this.identity = Base64.encode(identity)
    this.serviceCode = Base64.encode(appServiceCode)
    this.vCode = Base64.encode(verifyCode)
  }

}
